<template>
  <div>
    <base-alert v-if="processingError" dismissible :dismiss-callback="() => alert=false" type="danger">
      <!-- TODO: add error translation -->
      {{ processError }}
    </base-alert>
    <h5 class="info-text"> {{ $t('userAccountsSearch.secondStepValidationQuestion') }}</h5>

    <div v-if="account">
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="firstName">{{ $t('accountProfileDetails.firstName') }}</label>
          <input disabled class="form-control" id="firstName"
                 :placeholder="$t('accountProfileDetails.firstName')"
                 :value="account.personal_details.name"/>
        </div>
        <div class="form-group  col-md-6">
          <label for="surnameName">{{ $t('accountProfileDetails.lastName') }}</label>
          <input disabled class="form-control" id="surnameName"
                 :placeholder="$t('accountProfileDetails.lastName')"
                 :value="account.personal_details.surname"/>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="email">{{ $t('accountProfileDetails.emailAddress') }}</label>
          <input disabled class="form-control" id="email"
                 :placeholder="$t('accountProfileDetails.emailAddress')"
                 :value="account.personal_details.email"/>
        </div>
        <div class="form-group  col-md-6">
          <label for="referenceKey">{{ $t('accountProfileDetails.referenceKey') }}</label>
          <input disabled class="form-control" id="referenceKey"
                 :placeholder="$t('accountProfileDetails.referenceKey')"
                 :value="account.personal_details.reference_key"/>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="type">{{ $t('generic.type') }}</label>
          <input disabled class="form-control" id="type"
                 :placeholder="$t('generic.type')"
                 :value="account.type"/>
        </div>
        <div class="form-group  col-md-6">
          <label for="id">{{ $t('generic.id') }}</label>
          <input disabled class="form-control" id="id"
                 :placeholder="$t('generic.id')"
                 :value="account.id"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {BaseAlert} from 'src/components';

export default {
  name: 'review-account',
  components: {
    BaseAlert,
  },
  props: {
    processError: {
      type: String,
      description: "Wizard final processing error. E.g. user-reporting-profile add new user failure."
    }
  },
  data() {
    return {
      model: {
        validated: true,
        accountId: '',
      },
      alert: false
    };
  },
  computed: {
    error() {
      return this.$store.state.account.error
    },
    account() {
      return this.$store.state.account.data
    },
    processingError() {
      this.alert = this.processError != null;
      return this.alert
    }
  },
  methods: {
    validate() {
      this.model.accountId = this.account.id;
      this.model.type = this.account.type;
      this.$emit('on-validated', true, this.model);
      return Promise.resolve(true);
    }
  }
};
</script>
<style></style>
